import { render, staticRenderFns } from "./PolicyAndTerms.vue?vue&type=template&id=d782888c&"
import script from "./PolicyAndTerms.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PolicyAndTerms.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d782888c')) {
      api.createRecord('d782888c', component.options)
    } else {
      api.reload('d782888c', component.options)
    }
    module.hot.accept("./PolicyAndTerms.vue?vue&type=template&id=d782888c&", function () {
      api.rerender('d782888c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/components/PolicyAndTerms.vue"
export default component.exports